// extracted by mini-css-extract-plugin
export default {"card":"ForgotPassword_card__55yyE","submitButton":"ForgotPassword_submitButton__pQdvk","reCaptchaWrapper":"ForgotPassword_reCaptchaWrapper__BXG2q"};